import React from "react";

const instructions = [
  "🎟️ Join the Reunion Hall using the Entry Pass shared by the Organizer.",
  "📶 Ensure you have a stable internet connection throughout the event.",
  "📱 Use only one device and one registered account per participant.",
  "⏳ Read every question carefully and answer before the timer expires.",
  "🎤 Wait for the Organizer to announce the start before playing.",
  "🏆 Keep participating till the end for winner announcements.",
];

const rules = [
  "✅ Fair play is expected from every participant.",
  "🚫 No impersonation or multiple entries are allowed.",
  "🚫 Any attempt to cheat or manipulate scores may lead to immediate disqualification.",
  "🤝 Respect fellow participants and maintain a positive environment.",
  "📢 The Organizer's decisions regarding winners and prizes shall be final.",
  "📜 Participation signifies acceptance of all Reunion terms and conditions.",
];

const ReunionRules = () => {
  return (
    <section
      id="before-you-play"
      className="relative py-20 px-6 bg-gradient-to-b from-[#050505] via-[#081815] to-[#03110e]"
    >
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-4">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-emerald-500/10 border border-emerald-400/20 mb-5">
            <span className="text-xl">📖</span>
            <span className="uppercase tracking-[0.3em] text-xs font-semibold text-emerald-300">
              Before You Play
            </span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-black text-white mb-5">
            Play Fair.
            <br />
            Celebrate Together.
          </h2>

          <p className="max-w-3xl mx-auto text-emerald-100/80 text-sm lg:text-lg leading-relaxed">
            Please read the instructions, rules and disclaimer before joining
            any Reunion event.
          </p>
        </div>

        {/* Three Cards */}
        <div className="grid gap-8 lg:grid-cols-3">

          {/* Instructions */}
          <div className="rounded-3xl border border-emerald-500/20 bg-white/5 backdrop-blur-md p-7">
            <div className="text-5xl mb-4">📋</div>

            <h3 className="text-2xl font-bold text-white mb-5">
              Instructions
            </h3>

            <div className="space-y-2">
              {instructions.map((item, index) => (
                <p
                  key={index}
                  className="text-sm text-emerald-100/85 leading-relaxed"
                >
                  {item}
                </p>
              ))}
            </div>
          </div>

          {/* Rules */}
          <div className="rounded-3xl border border-emerald-500/20 bg-white/5 backdrop-blur-md p-7">
            <div className="text-5xl mb-4">⚖️</div>

            <h3 className="text-2xl font-bold text-white mb-5">
              Rules
            </h3>

            <div className="space-y-2">
              {rules.map((item, index) => (
                <p
                  key={index}
                  className="text-sm text-emerald-100/85 leading-relaxed"
                >
                  {item}
                </p>
              ))}
            </div>
          </div>

          {/* Disclaimer */}
          <div className="rounded-3xl border border-amber-500/20 bg-amber-500/5 backdrop-blur-md p-7">
            <div className="text-5xl mb-4">⚠️</div>

            <h3 className="text-2xl font-bold text-white mb-5">
              Disclaimer
            </h3>

            <div className="space-y-2 text-sm text-amber-100/90 leading-relaxed">
              <p className="text-gray-200">
                Reunion is a technology platform developed by Think5Whys and
                PurpleDoor to facilitate community engagement activities.
              </p>

              <p className="text-gray-200">
                Internet connectivity, mobile device performance, browser
                compatibility and battery availability are beyond the control
                of Think5Whys.
              </p>

              <p className="text-gray-200">
                Think5Whys does not guarantee uninterrupted connectivity,
                prize distribution or participant eligibility. Organizers are
                solely responsible for event content, prizes, winner selection
                and announcements.
              </p>

              <p className="text-gray-200">
                By participating, you acknowledge that Think5Whys shall not be
                liable for any direct, indirect, incidental, financial,
                technical, emotional or consequential loss arising from your
                participation in the event.
              </p>

              <p className="font-semibold text-amber-300">
                Participation in Reunion constitutes acceptance of these
                instructions, rules and disclaimer.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ReunionRules;